import React from 'react'
import {
  List,
  DatagridConfigurable,
  TextField,
  BooleanField,
  DateField,
  FunctionField,
  ShowButton,
  FilterButton,
  ExportButton,
  useRecordContext,
} from 'react-admin';
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const DownloadPdfButton = () => {
  const record = useRecordContext();
  if (!record || !record.pdf_url) return null;
  return (
    <Button
      size="small"
      startIcon={<DownloadIcon />}
      href={record.pdf_url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
    >
      Download PDF
    </Button>
  );
};

const VetCaseNameField = () => {
  const record = useRecordContext();
  if (!record || !record.vet_case) return null;
  const vc = record.vet_case;
  if (typeof vc === 'string') return <span>{vc}</span>;
  const horse = vc.horse && typeof vc.horse === 'object' ? vc.horse.name : (vc.horse || '—');
  return <span>{horse}{vc.case_number ? ` (#${vc.case_number})` : ''}</span>;
};

const ReportList = (props) => {
  const actions = (
    <>
      <FilterButton />
      <ExportButton />
    </>
  );

  return (
    <List {...props} perPage={50} sort={{ field: 'id', order: 'DESC' }} actions={actions}>
      <DatagridConfigurable bulkActionButtons={false}>
        <TextField source="id" label="ID" />
        <FunctionField label="Vet case" render={() => <VetCaseNameField />} sortable={false} />
        <BooleanField source="published" label="Published" />
        <FunctionField
          label="PDF"
          render={record => (record.pdf_url ? <DownloadPdfButton record={record} /> : '—')}
          sortable={false}
        />
        <DateField source="creation_date" label="Created at" showTime />
        <DateField source="update_date" label="Updated at" showTime />
        <ShowButton />
      </DatagridConfigurable>
    </List>
  );
};

export default ReportList;
